export default __webpack_public_path__ + "static/growingBussinessBg-124f2eb6a7cae3eb58f5ac20e54a5596.png";